<footer class="footer-area">
    <div class="container">
        <h3><a routerLink="/"><span>hit</span><small>-FLUENCER</small></a></h3>
        <ul>
            <li><a href="#" target="_blank" class="fab fa-facebook-f"></a></li>
            <li><a href="#" target="_blank" class="fab fa-twitter"></a></li>
            <li><a href="#" target="_blank" class="fab fa-linkedin-in"></a></li>
            <li><a href="#" target="_blank" class="fab fa-instagram"></a></li>
        </ul>
        <p>© {{year}} All right reserved - Hit-Fluencer</p>
    </div>
</footer>

<ngx-scrolltop></ngx-scrolltop>
